var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from "react";
import { LayoutContext } from "../../layout-context";
import { StyledThead } from "./styled";
import { ColumnHead } from "../column-head";
var tableHeadRenderOptions = {
    thead: {
        block: function (_a) {
            var children = _a.children;
            return React.createElement("div", { className: "table-head" }, children);
        },
        table: function (_a) {
            var children = _a.children;
            return React.createElement(StyledThead, null, children);
        },
    },
    headerGroup: {
        block: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return (React.createElement("div", __assign({ className: "header-group" }, props), children));
        },
        table: function (_a) {
            var children = _a.children, props = __rest(_a, ["children"]);
            return React.createElement("tr", __assign({}, props), children);
        },
    },
};
var TableHeadLayout = function (_a) {
    var children = _a.children, layoutType = _a.layoutType;
    var renderTableHead = tableHeadRenderOptions.thead[layoutType];
    return renderTableHead({ children: children });
};
var HeaderGroup = function (_a) {
    var children = _a.children, layoutType = _a.layoutType, props = __rest(_a, ["children", "layoutType"]);
    var renderHeaderGroup = tableHeadRenderOptions.headerGroup[layoutType];
    return renderHeaderGroup(__assign({ children: children }, props));
};
export var TableHead = function (_a) {
    var headerGroups = _a.headerGroups, sortableBy = _a.sortableBy, customProps = _a.customProps;
    var layoutType = useContext(LayoutContext);
    return (React.createElement(TableHeadLayout, { layoutType: layoutType }, headerGroups.map(function (headerGroup) {
        var _a = headerGroup.getHeaderGroupProps(), key = _a.key, headerGroupProps = __rest(_a, ["key"]);
        return (React.createElement(HeaderGroup, __assign({ key: key }, headerGroupProps, { layoutType: layoutType }), headerGroup.headers.map(function (column) {
            var key = column.getHeaderProps().key;
            return (React.createElement(ColumnHead, { key: key, column: column, sortableBy: sortableBy, customProps: customProps }));
        })));
    })));
};
